import "./src/css/style.css";
import React from "react";

// Load Roboto typeface
require("typeface-roboto");

export const wrapPageElement = ({ element }) => <>{element}</>;
